import * as angular from 'angular';
import { Decimal } from 'decimal.js';

export class VolumeBasedTariffService {
    calculateVolumeBasedTariff(
        price: Decimal,
        alpha: Decimal,
        duration: Decimal,
        maxVolume: Decimal,
        minVolume: Decimal,
        bookedCapacity: Decimal
    ): Decimal | null {
        const quantityToUseAsBookedCapacity: Decimal =
            bookedCapacity.lessThan(maxVolume) &&
            bookedCapacity.greaterThan(minVolume)
                ? bookedCapacity
                : maxVolume.minus(1);

        const volumeBasedRegulatedTariff: Decimal = price
            .times(
                new Decimal(1).minus(
                    alpha
                        .dividedBy(1000000)
                        .times(quantityToUseAsBookedCapacity)
                )
            )
            .times(duration);

        return volumeBasedRegulatedTariff.toDecimalPlaces(8);
    }

    matchesTariffGroup(
        maxQuantity: Decimal,
        tariffGroupMinVolume: Decimal,
        minQuantity: Decimal,
        tariffGroupMaxVolume: Decimal
    ) {
        return (
            maxQuantity.greaterThanOrEqualTo(tariffGroupMinVolume) &&
            minQuantity.lessThanOrEqualTo(tariffGroupMaxVolume)
        );
    }
}

angular
    .module('app')
    .service('volumeBasedTariffService', VolumeBasedTariffService);
